<template>
    <div> 
        <p class="text-white">
            Solicitar tarjeta física
        </p>
        <div>

        </div>
        <div class="flex flex-col w-full gap-4">
            TODO: Poner form aca
        </div>
    </div>
</template>
